import styled, { css } from 'styled-components';
import { lighten, darken, transparentize } from 'polished';
import { Container as SwitchContainer } from 'components/Switch/styles';

interface TdFlagProps {
  $isGe?: boolean;
  isIndisponivel?: boolean;
  isSelected?: boolean;
  size?: string;
}
interface TdProps {
  disabled?: boolean;
}

export const Container = styled.div`
  width: -webkit-fill-available;
  width: -moz-available;
  display: flex;
  flex-direction: column;

  > header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
    > div {
      display: flex;
      align-items: center;
      min-width: 250px;
      width: 100%;
    }
    h4 {
      min-width: 130px;
    }
  }
  > div {
    height: calc(100vh - 146px);
  }
`;

export const Table = styled.table`
  caret-color: transparent;
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;

  thead {
    tr {
      th {
        text-align: left;
        padding: 10px 0px;
        color: ${props => props.theme.fontColor};
        font-size: 1.0625rem;
        font-weight: 400 !important;
      }
    }
  }

  tbody {
    tr {
      border-bottom: 0.1px solid
        ${props => transparentize(0.7, props.theme.fontColor)};
      &:last-of-type {
        border-bottom: none;
      }
      td {
        padding: 10px 0px;
        font-size: 1.0625rem;
        color: ${props => props.theme.fontColor};

        button {
          margin: 0;
        }
        &:nth-of-type(8) {
          text-align: center;
        }
      }
      &:hover {
        transition: all 0.25s ease;
        ${props =>
          props.theme.name === 'dark'
            ? css`
                background-color: ${props =>
                  lighten(0.03, props.theme.cardBackgroud)};
              `
            : css`
                background-color: ${props =>
                  darken(0.03, props.theme.cardBackgroud)};
              `}
      }
    }
  }
`;

export const InfoPlanilha = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end !important;
  height: 100%;
  p {
    text-align-last: right;
    font-size: 0.75rem;
    color: ${props => transparentize(0.4, props.theme.fontColor)};
  }
`;

export const TdFlag = styled.td<TdFlagProps>`
  width: ${props => props.size + 'rem'};
  font-size: 1.0625rem;
  color: ${props => props.theme.fontColor};
  div {
    margin-right: 5px;
    width: 10px;
    height: 40px;

    ${props =>
      props.$isGe && !props.isIndisponivel
        ? css`
            background: ${props.theme.button.warn.in};
          `
        : !props.$isGe && props.isIndisponivel
        ? css`
            background: ${props.theme.button.danger.out};
          `
        : props.$isGe && props.isIndisponivel
        ? css`
            background-image: linear-gradient(
              ${props.theme.button.danger.out},
              ${props.theme.button.warn.in}
            );
          `
        : css`
            pointer-events: none;
          `}
  }
`;

export const Td = styled.td<TdProps>`
  /* padding: 10px 10px 10px 0px !important; */
  font-size: 1.0625rem;
  color:${props =>
    props.disabled
      ? props.theme.secondaryFontColor
      : props.theme.fontColor} !important;
  text-decoration: ${props => (props.disabled ? 'line-through' : 'none')};
  ${SwitchContainer} {
    display: flex;
    justify-content: center;
}

  strong {
    /* opacity:  ${props => (props.disabled ? 1 : 0.2)};
  color: ${props => (props.disabled ? 'red' : props.theme.fontColor)}; */
  color:${props =>
    props.disabled
      ? props.theme.secondaryFontColor
      : props.theme.fontColor} !important;
    margin-left: 5px;
    font-size: 0.88rem;
    font-weight: normal;
    font-style: italic;

    &:before {
      content: '-';
      margin-right: 10px;
    }
  }
//Comentado estilização de button dentro de tabelas
// Sem margin, eles se agrupam na direita da tabela e os botões na tela de
//aprovacao ficam melhor centralizados
  /* button {
    margin: 0 auto !important;
  } */
`;
